export const init = (): void => {
  storeDiscountData();
};

const storeDiscountData = (): void => {
  const params = new URLSearchParams(window.location.search);
  const discount_code = params.get("discount");

  // Store the discount value in a cookie for 30 days
  if (discount_code) {
    setCookie("discount_code", discount_code, 30);
  }
};

const setCookie = (name: string, value: string, days: number): void => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

  const domain = window.location.hostname.split(".").slice(-2).join(".");
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/; domain=${domain}`;
};
